import { ADD_PROFILE_DETAILS, ADD_PROFILE_IMAGE, USER_ID } from './action';

const initialState = {
  profile_setting: null,
  user_id: ""
};

export const profileReducer = (state = initialState, action: any) => {

  switch (action.type) {
    case ADD_PROFILE_DETAILS:
      return {
        ...state,
        profile_setting: action.payload,
      };
    case ADD_PROFILE_IMAGE:
      return {
        ...state,
        profile_setting: action.payload.file,
      };
    case USER_ID:
      return {
        ...state,
        user_id: action.payload
      }
    default:
      return state;
  }
};
